import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { Card } from "../components/ui/card";
import { formatDateTime } from "../lib/format";

export default function SyncLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sync/logs").then(({ data }) => { setLogs(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold text-slate-900">Sync log</h1>
        <p className="text-slate-500 mt-1">Full history of all syncs across recruiters.</p>
      </div>

      <Card className="p-0 border-slate-200 overflow-hidden">
        {loading && <div className="p-6 text-slate-500">Loading…</div>}
        {!loading && logs.length === 0 && <div className="p-6 text-slate-400">No syncs yet.</div>}
        {!loading && logs.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
                <tr>
                  <th className="text-left py-3 px-6 font-semibold">Recruiter</th>
                  <th className="text-left py-3 px-6 font-semibold">Time</th>
                  <th className="text-right py-3 px-6 font-semibold">Added</th>
                  <th className="text-right py-3 px-6 font-semibold">Updated</th>
                  <th className="text-right py-3 px-6 font-semibold">Rejected</th>
                  <th className="text-left py-3 px-6 font-semibold">Errors</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((s) => (
                  <tr key={s.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`log-row-${s.id}`}>
                    <td className="py-3 px-6 font-medium text-slate-900">{s.by}</td>
                    <td className="py-3 px-6 text-slate-600">{formatDateTime(s.ts)}</td>
                    <td className="py-3 px-6 text-right text-emerald-600 font-medium">+{s.added}</td>
                    <td className="py-3 px-6 text-right text-indigo-600 font-medium">{s.updated}</td>
                    <td className="py-3 px-6 text-right text-amber-600 font-medium">{s.rejected_count}</td>
                    <td className="py-3 px-6 text-red-600 text-xs">{s.errors?.length || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </Layout>
  );
}
